import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';

// import { useForm } from '../../hooks/useForm';
// import { startLogin } from '../../redux/actions/auth';

import './recover_password.css';
import logoPretzu from '../../assets/logos_pretzu/logo_login.svg';
import { ModalRecoverPassword } from './ModalRecoverPassword';
// import { toast } from 'react-toastify';
/* import loginLinea from './login_linea.svg'; */
import { fetchSinToken } from './../../helpers/fetch';
import { CircularProgress } from '@mui/material';

export const RecoverPassword = () => {

    const navigate = useNavigate()

    const [open, setOpen] = useState(false)
    const [email, setEmail] = useState('')
    const [msgError, setMsgError] = useState('')
    const [loading, setLoading] = useState(false)

    const sendEmail = async (e) => {
        try {
            e.preventDefault();

            setMsgError('')

            if (email === '') {
                setMsgError('El email es requerido')
                return false
            }

            setLoading(true)

            const resp = await fetchSinToken('recover_password', { email }, 'POST');
            const body = await resp.json();

            if (body.ok) {
                setOpen(true)
            } else {
                setMsgError(body.msg)
                return false
            }

            setLoading(false)

        } catch (error) {

            setMsgError('Error interno')
            console.log(error)

            setLoading(false)

        }

    }

    const handleChange = ({ target }) => {
        setEmail(target.value)
    }

    const handleClose = () => {
        navigate(-1)
        setOpen(false)
    };

    return (
        <div className='container'>
            <div className='row d-flex justify-content-center ContainerLogin'>

                <div className="col-md-5">

                    <div className="flex justify-center">
                        <img
                            src={logoPretzu}
                            alt="logo pretzu"
                        />
                    </div>

                    <div className='mt-5'>
                        <h1 className='p-title-recover-password text-center'>Recuperar Contraseña</h1>
                    </div>

                    <div className='row m-3'>
                        <div className="col text-center">
                            <h5 className='p-text-recover-password'>Ingresa tu correo registrado y te enviaremos las instrucciones para cambiar tu contraseña.</h5>
                        </div>
                    </div>

                    <form className='login m-4'
                        onSubmit={sendEmail}
                    >
                        <div className="mb-4">
                            <label htmlFor="exampleInputEmail1" className="form-label">Correo electrónico</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                id="loginEmail"
                                placeholder="Ingresa tu correo"
                                value={email || ''}
                                onChange={handleChange}
                            />
                        </div>

                        {msgError !== '' &&
                            < div style={{ color: 'red', textAlign: 'center', margin: '10px', fontSize: '20px' }}>{msgError}</div>
                        }

                        {loading ?
                            <div className='text-center'><CircularProgress color="secondary" /></div>
                            :
                            <button type="submit" className={(email) ? 'btn p-text-enviar' : 'btn disabled'}>ENVIAR</button>
                        }

                    </form>

                    <ModalRecoverPassword
                        open={open}
                        handleClose={handleClose}
                    />

                </div>
            </div >
        </div >
    )
}
